import React from 'react';
import { css } from 'emotion';
import { AdSlot } from '@root/src/web/components/AdSlot';
import { namedAdSlotParameters } from '@root/src/model/advertisement';
const adSlotWrapper = (height) => css `
    position: static;
    height: ${height}px;
`;
const stickyAdSlot = css `
    position: sticky;
    top: 0;
`;
export const StickyAd = ({ name, height }) => (React.createElement("div", { className: adSlotWrapper(height) },
    React.createElement(AdSlot, { asps: namedAdSlotParameters(name), localStyles: stickyAdSlot })));
